import React from 'react'
import {useSelector} from 'react-redux'
import styled from '@emotion/styled'
import {Hotel} from '@findhotel/sapi'
import {useGetRoomLabels} from 'components/Offer/hooks/useGetRoomLabels'
import {SplitBookingOfferInfo} from 'components/Offer/types'
import {getSplitBookingDetails} from 'modules/sapiSearch/selectors'
import {equals, intersection, last} from 'ramda'

import {Text} from '@vio/atlas/Text'
import {cssTheme} from '@vio/atlas/themes'

export interface Props {
  /** Hotel Id */
  hotelId: Hotel['objectID']
  /** Offer state */
  offers: SplitBookingOfferInfo[]
}

const RoomLabelsText = styled(Text)`
  color: ${cssTheme.colors.content.success.secondary};
  &.--is-alternative-color {
    color: ${cssTheme.colors.content.neutral.secondary};
  }
  /* Always have your choice label display in the default color */
`

const RoomLabelsItem = styled.span`
  display: inline-block;
  margin-right: ${cssTheme.layout.spacing.s200};
`

const Dot = styled(RoomLabelsText)`
  display: inline-block;
  margin-left: ${cssTheme.layout.spacing.s200};
`

export const SplitBookingRoomLabels = ({hotelId, offers}: Props) => {
  const {cancellationPenalties} = useSelector(state =>
    getSplitBookingDetails(state, hotelId)
  )

  const [first, second] = offers

  const translatedLabelsFirstOffer = useGetRoomLabels({
    offer: {...first?.offer, cancellationPenalties},
    isSplitBooking: true
  })
  const translatedLabelsSecondOffer = useGetRoomLabels({
    offer: {...second?.offer, cancellationPenalties},
    isSplitBooking: true
  })
  const labels = intersection(
    translatedLabelsFirstOffer,
    translatedLabelsSecondOffer
  )

  if (labels.length <= 0) return null

  return (
    <RoomLabelsText
      variant="bodyXS"
      dataId="RoomLabels"
      className={'--container-rooms-label'}
    >
      {labels.map(label => (
        <RoomLabelsItem key={label}>
          {label}
          {!equals(last(labels), label) && (
            <Dot variant="bodyXS" as="span">
              ·
            </Dot>
          )}
        </RoomLabelsItem>
      ))}
    </RoomLabelsText>
  )
}
